import registry from "~/components/DoRegistry.js";
import DoFlash from "~/components/flashmsg/DoFlash.js";

//import template from "./ajaxMsgBox.hbs";

var niceMessage = function(status){
    switch(status){
        case 403:
            return "You are not allowed to access that resource.";
        case 404:
            return "The requested resource could not be located.";
        case 400:
        case 405:
            return "Bad Request.  You cannot perform current action.";
        case 500:
            return "An internal error occurred.  If this continues please contact an administrator.";
        default:
            return "Unknown error.";
    };
};

/**
 * Allows reuse of the alert error code for making xhr requests.
 * @param {jqXHR} xhr The jQuery xhr object.
 * @param {String} textStatus The status message.  Such as OK
 * @param {String} errorThrown An error message such as "Bad Request".
 */
var xhrError = function(xhr, textStatus, errorThrown){

    if(textStatus === "timeout"){
        return "A timeout occurred.  Please try again.";
    };

    var message = (parseInt(xhr.status) > 0) ? xhr.status + ": "+niceMessage(xhr.status) : niceMessage(xhr.status);

    try{
        var temp = jQuery.parseJSON(xhr.responseText);
        message = "(" + temp.status + ") " + temp.message;
    }catch(err){
        //do nothing
        if(console){ console.log(err); }
    }

    return message;
}

//initiallize things
$(document).ready(function(){
    if(!$('#doAjaxWrapper').length) {
        $(document.body).append('<div id="doAjaxWrapper" class="ajaxResults message printHide"></div>');
    }
});

class DoAjax {
    constructor($errorTarget, timeout=30000, contentType="application/json"){
        this.flash = new DoFlash($errorTarget);
        this.timeout = timeout;
        this.contentType = contentType;
    }

    page($target, url){
        return this.ajax("GET", url, null, true).fail(function(){$target.html("<h2>Failed to load content.</h2>")});
    }

    doGet(url){
        return this.ajax("GET", url, null, true);
    }

    doDelete(url){
        return this.ajax("DELETE", url, null, true);
    }

    doPut(url){
        return this.ajax("PUT", url, null, true);
    }

    doPost(url, jsonBody){
        return this.ajax("POST", url, jsonBody, true);
    }

    ajax(method, url, jsonBody, showErrorMsg, successMsg, successDetails, timeout){
        showErrorMsg = showErrorMsg || false;

        let self = this;

        let params = {
            method: method,
            url: url,
            cache: false,
            contentType: this.contentType,
            timeout: (timeout || this.timeout) || 30000 //30 seconds
        };

        if (jsonBody) {
            if (typeof jsonBody === 'object') {
                params.data = JSON.stringify(jsonBody);
                params.dataType = 'json';
            } else if (typeof jsonBody === 'string') {
                params.data = jsonBody;
            }
        }

        var $defer = $.Deferred();
        var $promise = $.ajax(params);

        $promise.fail(function (xhr, textStatus, errorThrown) {
            var message = xhrError(xhr, textStatus, errorThrown);
            $defer.reject(xhr, textStatus, errorThrown, message);
            if(showErrorMsg){
                self.flash.flash("error", message, [method+" "+url]);
            }
        });

        $promise.done(function(data){
            $defer.resolve(data);
            if(successMsg){
                self.flash.flash("success", successMsg, successDetails);
            }
        });

        return $defer.promise();
    }
}

registry.register(__filename, DoAjax);
export default DoAjax;